import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import './Breadcrumbs.scss'

import FILTERS from '@helpers/filters'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as SHARED_ACTION from '@store/shared/actions'

class Breadcrumbs extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      location: this._getPath(),
    }
    this.el = React.createRef()
  }

  _getPath() {
    return window.location.pathname.replace(/\/$/, '').split('/')
  }

  componentWillReceiveProps() {
    this.setState({
      location: this._getPath(),
    })
  }

  locationHelper(path, helper) {
    switch (path) {
      case 'simulador-cva-mcmv':
      case 'simulador':
        return 'Simulador'
      case 'vivantagens-sao-paulo':
        return 'Vivantagens São Paulo'
      case 'sobre-nos':
        return 'Sobre nós'
      case 'mapa-de-lojas':
        return 'Mapa de Lojas'
      case 'sala-de-imprensa':
        return 'Sala de Imprensa'
      case 'casavivaz':
        return 'Casa Vivaz'
      case 'contato':
        return 'Contato'
      case 'duvidas-frequentes':
        return 'Dúvidas'
      case 'instituto-cyrela':
        return 'Instituto Cyrela'
      case 'erro-404':
        return 'Erro 404'
      case 'apartamentos':
        if (helper) {
          return `Apartamentos ${helper.Preposicao} ${helper.Nome} - ${helper.Uf}`
        } else {
          return 'Apartamentos'
        }
      case 'apartamento':
        return 'Apartamentos'
      /* case 'vendedor':
        if (helper) {
          return `Apartamentos ${helper.Preposicao} ${helper.Nome} - ${helper.Uf}`
        } else {
          return 'Apartamentos'
        } */

      default:
        break
    }
  }

  imovelHelper(str) {
    let strlen = str.split(' ').length
    if (strlen > 4) {
      strlen = 2
    }
    return str.split(' ').slice(0, strlen).join(' ')
  }

  render() {
    let { region } = this.props
    let { regions } = this.props
    let currentProduct = this.props.product
    let currentRegion = null
    if (regions.estados && region !== undefined) {
      currentRegion = regions.estados.filter(x => x.IdEstado === region)[0]
    }

    return (
      <div className='breadcrumbs'>
        <div className='grid-container mt2 mb4'>
          <nav aria-label='Você está aqui:'>
            {this.state.location.length === 2 &&
              <ul className={`breadcrumbs${this.state.location[1] === 'casavivaz' ? ' breadcrumbs__casa-vivaz' : ''}`}>
                <li>
                  <Link to='/'>Home</Link>
                </li>
                <li>
                  <span className='show-for-sr'>Atual</span>
                  <strong>{this.locationHelper(this.state.location[1])}</strong>
                </li>
              </ul>
            }
            {this.state.location.length === 3 &&
              <ul className='breadcrumbs'>
                <li>
                  <Link to='/'>Home</Link>
                </li>
                {(this.state.location[1]) !== 'erro-404' &&
                  (this.state.location[1]) !== 'apartamentos' &&
                  (this.state.location[1]) !== 'apartamento' &&
                  (this.state.location[1]) !== 'vendedor' &&
                  (this.state.location[1]) !== 'campanhas' &&
                  <li>
                    <Link to={'/' + this.state.location[1]}>{this.locationHelper(this.state.location[1])}</Link>
                  </li>
                }
                {(this.state.location[1]) === 'apartamento' && currentRegion &&
                  <li>
                    <Link to={'/apartamentos/' + this.props.regions.estados.filter(x => x.IdEstado === this.props.region)[0].Url}>{this.locationHelper('apartamentos', currentRegion)}</Link>
                  </li>
                }
                {/* {(this.state.location[1]) === 'vendedor' && currentRegion &&
                  <li>
                    <Link to={'/apartamentos/' + this.props.regions.estados.filter(x => x.IdEstado === this.props.region)[0].Url}>{this.locationHelper('apartamentos', currentRegion)}</Link>
                  </li>
                } */}
                {(this.state.location[1]) === 'erro-404' && (
                  <li>
                    <strong>{this.locationHelper(this.state.location[1])}</strong>
                  </li>
                )}
                <li>
                  <span className='show-for-sr'>Atual</span>
                  {(this.state.location[1]) !== 'apartamentos' && (this.state.location[1]) !== 'apartamento' &&
                    <strong>{FILTERS.capitalize(this.state.location[2])}</strong>
                  }
                  {(this.state.location[1]) === 'apartamentos' &&
                    <strong>{this.locationHelper(this.state.location[1], currentRegion)}</strong>
                  }
                  {(this.state.location[1]) === 'apartamento' &&
                    <strong>{currentProduct.imovel ? currentProduct.imovel.Nome : ''}</strong>
                  }
                </li>
              </ul>
            }
            {this.state.location.length === 4 &&
              <ul className='breadcrumbs'>
                <li>
                  <Link to='/'>Home</Link>
                </li>
                {currentRegion &&
                  <li>
                    <Link to={'/apartamentos/' + this.props.regions.estados.filter(x => x.IdEstado === this.props.region)[0].Url}>{this.locationHelper('apartamentos', currentRegion)}</Link>
                  </li>
                }
                {currentProduct.imovel &&
                  <li>
                    <Link to={'/' + this.state.location[1] + '/' + this.state.location[2]}>{currentProduct.imovel.Nome}</Link>
                  </li>
                }
                <li>
                  <span className='show-for-sr'>Atual</span>
                  <strong>{FILTERS.capitalize(this.state.location[3])}</strong>
                </li>
              </ul>
            }
          </nav>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {

  return {
    product: state.products.product,
    region: state.shared.region,
    regions: state.shared.regions,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs))



// WEBPACK FOOTER //
// ./src/components/shared/elements/Breadcrumbs/Breadcrumbs.js